<div class="bloco" [formGroup]="form">
  <div class="row g-3">
    <div class="col-12">
      <app-alert-card type="info" icon="info">
        O DIFAL se aplica a operações interestaduais destinadas a consumidor final não contribuinte do ICMS.
      </app-alert-card>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Base de cálculo</mat-label>
        <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseCalculo" class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Alíquota interestadual (%)</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaInterestadual" class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Alíquota interna do destino (%)</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaInternaDestino" class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Partilha para a UF de destino (%)</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualPartilha" class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>Alíquota ICMS FCP (%)</mat-label>
        <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcpDestino" class="campo-numero">
        <mat-hint>Percentual do ICMS relativo ao Fundo de Combate à Pobreza</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-12">
      <div class="sub-section-container">
        <div class="sub-section-title">
          <mat-icon>calculate</mat-icon>
          <span>Valores apurados</span>
        </div>
        @if (isRecalculoPendente || form.get('valorIcmsDestino')?.value == null) {
          <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
        } @else {
          <div class="row g-3">
            <div class="col-6 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>ICMS de partilha - UF de destino</mat-label>
                <input matInput type="text" [value]="form.get('valorIcmsDestino')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
              </mat-form-field>
            </div>
            <div class="col-6 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>ICMS de partilha - UF do remetente</mat-label>
                <input matInput type="text" [value]="form.get('valorIcmsRemetente')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
              </mat-form-field>
            </div>
            <div class="col-6 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Valor do ICMS FCP</mat-label>
                <input matInput type="text" [value]="form.get('valorFcpDestino')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
